<template>
	<div class="page user-info">
		<!-- 用户基本信息 -->
		<!-- <user-info-card user-info="userInfo"></user-info-card> -->
		<div class="user-info-header">
			<head-image :id="userInfo.id" :name="userInfo.nickName" :url="userInfo.headImage" :size="60" class="head-image"
				:isShowUserInfo="false"></head-image>

			<div class="user-basic-info">
				<div class="nickname-sex">
					<span class="nickname">{{ userInfo.nickName }}</span>
					<span v-show="userInfo.sex == 0" class="iconfont icon-man"></span>
					<span v-show="userInfo.sex == 1" class="iconfont icon-girl"></span>
				</div>
				<div class="info-text">
					<span class="label-text">用户名:</span>
					<span class="content-text">{{ userInfo.userName }}</span>
				</div>
				<div class="info-text" v-if="isFriend">
					<span class="label-text">备注:</span>
					<span class="content-text">{{ friendInfo.showNickName }}</span>
				</div>
				<div class="info-text" v-if="userInfo.signature">
					<span class="label-text">签名:</span>
					<span class="content-text">{{ userInfo.signature }}</span>
				</div>
			</div>
		</div>
		<div class="bar-group">
			<!-- <el-row class="arrow-item" type="flex" justify="space-between" align="middle" @click="handleSetRemark">
				<div class="item-title">设置备注</div>
				<i class="el-icon-arrow-right"></i>
			</el-row> -->
			<div @click="handleClearChat">
				<el-row class="arrow-item" type="flex" justify="space-between" align="middle">
					<div class="item-title">清除聊天记录</div>
					<i class="el-icon-arrow-right"></i>
				</el-row>
			</div>
			<el-row class="arrow-item" type="flex" justify="space-between" align="middle">
				<div class="item-title">加入黑名单</div>
				<el-switch title="加入黑名单" :value="userInfo.isInBlacklist" @change="onBlacklistChange"></el-switch>
			</el-row>
		</div>
		<div class="bar-group btn-group">
			<!-- <el-button type="primary" @click="sendMessage">发送消息</el-button> -->
			<el-button type="danger" @click="deleteFriend" v-show="isFriend">删除好友</el-button>
		</div>

	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
export default {
	name: "chatPrivateSide",
	components: {
		HeadImage
	},
	data() {
		return {
			userInfo: {
				id: null,
				nickName: null,
				headImage: null
			},
			requestId: null,
			isCleanMessage: true,
			userId: null,
			visible: false
		}
	},
	props: {
		friend: {
			type: Object,
			required: true
		},
	},
	computed: {
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friendInfo() {
			return this.friendStore.findFriend(this.userInfo.id);
		},
	},
	methods: {
		handleClearChat() {
			this.$confirm(`确认删除与对方的聊天记录吗??`, '清空聊天记录', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let chat = {
					type: 'PRIVATE',
					targetId: this.userInfo.id,
					showName: this.userInfo.nickName,
					headImage: this.userInfo.headImage,
				};
				const idx = this.chatStore.findChatIdx(chat)
				this.chatStore.cleanMessage(idx);
				this.$message.success("您清空了对方的聊天记录")
			})
		},
		onBlacklistChange(e) {
			const isChecked = e;
			this.userInfo.isInBlacklist = isChecked;
			if (isChecked) {
				this.$confirm(`您将不再收到对方的消息,确认将'${this.userInfo.nickName}'移入黑名单吗?`, '加入黑名单', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						url: "/blacklist/add?userId=" + this.userInfo.id,
						method: "POST"
					}).then(() => {
						this.$message.success("已将对方加入黑名单")
					}).catch(() => {
						this.userInfo.isInBlacklist = !isChecked;
					})
				})

			} else {
				this.$http({
					url: "/blacklist/remove?userId=" + this.userInfo.id,
					method: "DELETE"
				}).catch(() => {
					this.userInfo.isInBlacklist = !isChecked;
				})
			}
		},
		deleteFriend() {
			this.$confirm(`确认删除'${this.userInfo.nickName}',并清空聊天记录吗?`, '确认解除?', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: `/friend/delete/${this.userInfo.id}`,
					method: 'delete'
				}).then(() => {
					this.$message.success("删除好友成功");
					this.friendStore.removeFriend(this.userInfo.id);
					this.chatStore.removePrivateChat(this.userInfo.id);
				})
			})
		},
		loadUserInfo(id) {
			this.$http({
				url: "/user/find/" + id,
				method: 'GET'
			}).then((user) => {
				this.userInfo = user;
			})
		},

	},
	mounted() {
		this.userInfo = this.loadUserInfo(this.friend.id);
	}
}
</script>

<style lang="scss" scoped>
.user-info-header {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	margin-left: 25px;
}

.head-image {
	margin-right: 16px;
}

.user-basic-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	text-align: left;
}

.nickname-sex {
	display: flex;
	align-items: center;
	margin-bottom: 6px;

	.nickname {
		font-size: 16px;
		font-weight: bold;
		margin-right: 8px;
	}
}

.info-text {
	margin-bottom: 4px;
	font-size: 14px;

	.label-text {
		color: #888;
		margin-right: 4px;
	}

	.content-text {
		color: #333;
	}
}

.page.user-info {
	height: 100%;
	padding: 16px;
	width: 280px;
	box-sizing: border-box;
}

.icon-man {
	color: darkblue;
}

.icon-girl {
	color: darkred;
}

.bar-group {
	margin: 12px 0;
	padding: 0 16px;
	background-color: #fff;
}

.arrow-item {
	padding: 15px 0;
	border-bottom: 1px solid #f0f0f0;
	cursor: pointer;

	.item-title {
		font-size: 14px;
		color: #333;
	}
}

.arrow-item:last-child {
	border-bottom: none;
}

.btn-group {
	display: flex;
	justify-content: space-around;
	padding-top: 12px;

	.el-button {
		flex: 1;
		margin: 0 6px;
	}
}
</style>